import http from "@/common/http.service";
const ROOT_URL = "campaign";
const DELETE_URL = "campaign/delete";
const DUPLICATE_URL = "campaign/copy";
const TEST_MAIL_URL = "campaign/sentTest";
const CAMPAIGN_ABORT = "report/campaign/abort";
const CAMPAIGN_PAUSE = "campaign/pause";
const CAMPAIGN_RESUME = "campaign/resume";
const CAMPAIGN_SAVE = "campaign/save";
const AUTO_SAVE = "campaign/autosave-html";
const SAVE_RECIPIENTS = "campaign/save-recipients";
const RECIPIENT_LIST = "campaign/recipient-list";
const SEGMENT_LIST = "campaign/segment-list";
const CAMP_DETAILS = "campaign/campaign_summary";
const PUPLISH_CAMPAIGN = "campaign/publish";
const SPAM_CHECK = "service/spam-check";
const LINK_CHECK = "campaign/update-broken-link";
const REMOVE_TEMPLATE = "campaign/remove-template";
const CREATE_IMAGE = "campaign/create-image";
const AI_SUBJECTLINE = "panel/campaign/subjectline";
const AI_CLICKCOUNT = "panel/campaign/fetchrequest";
const REQUEST_AMP = "panel/campaign/allowAmp";
const CAMAPIGN_ANALYTICS_EXPORT = "report/download-analytics";
const PREVIEW_SIZE = "panel/campaign/previewsize";

export default {
  getTemplateSize(params) {
    return http.post(PREVIEW_SIZE, params).then(function (response) {
      return response;
    });
  },
  sentRequest(params) {
    return http.post(REQUEST_AMP, params).then(function (response) {
      return response.status;
    });
  },
  getClickCount(params) {
    return http.post(AI_CLICKCOUNT, params).then(function (response) {
      return response;
    });
  },
  generateSubLines(params) {
    return http.post(AI_SUBJECTLINE, params).then(function (response) {
      return response;
    });
  },
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.listdata.list,
        total: response.data.total,
      };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id, status: 3 });
  },

  duplicate(id) {
    return http.post(DUPLICATE_URL, { id: id });
  },

  testMail(params) {
    return http.post(TEST_MAIL_URL, params);
  },

  abortCampaign(params) {
    return http.post(CAMPAIGN_ABORT, params);
  },
  pauseCampaign(params) {
    return http.post(CAMPAIGN_PAUSE, params);
  },
  resumeCampaign(params) {
    return http.post(CAMPAIGN_RESUME, params);
  },
  deleteTemplate(params) {
    return http.post(REMOVE_TEMPLATE, params);
  },
  saveCampaign(params) {
    params = { ...params };
    if (params.plaintext) {
      params.plaintext = Buffer.from(params.plaintext).toString("base64");
    }
    if (params.ampContent) {
      params.ampContent = Buffer.from(params.ampContent).toString("base64");
    }

    if (params.html) {
      params.html = Buffer.from(params.html).toString("base64");
    }
    if (params.tempJson) {
      params.tempJson = Buffer.from(params.tempJson).toString("base64");
    }
    return http.post(CAMPAIGN_SAVE, params);
  },
  autoSave(params) {
    params = { ...params };
    params.html = Buffer.from(params.html).toString("base64");
    params.tempJson = Buffer.from(params.tempJson).toString("base64");
    return http.post(AUTO_SAVE, params);
  },
  saveRecipients(params) {
    return http.post(SAVE_RECIPIENTS, params);
  },
  publishCampaign(params) {
    return http.post(PUPLISH_CAMPAIGN, params);
  },

  getRecipients(params, cb) {
    return http.post(RECIPIENT_LIST, params).then(function (response) {
      var data = { contactList: response.data.normal_list };
      cb(data);
    });
  },
  getSegments(params, cb) {
    return http.post(SEGMENT_LIST, params).then(function (response) {
      var data = { segmentList: response.data.segment };
      cb(data);
    });
  },

  getSingleItem(id, cb) {
    return http.post(CAMP_DETAILS, { camp_id: id }).then(function (response) {
      cb(
        response.data.campaign,
        Object.values(response.data.campaignB).length
          ? response.data.campaignB
          : false
      );
    });
  },

  getReport(url, params) {
    return http.post(url, params);
  },

  fetchSpamScore(params, cb) {
    http.post(SPAM_CHECK, params).then(function (response) {
      var spamScore =
        response.data.campaignA && response.data.campaignA.score
          ? response.data.campaignA.score
          : "";
      var spamReport =
        response.data.campaignA && response.data.campaignA.details
          ? response.data.campaignA.details
          : [];
      var blacklistDetails =
        response.data.blackListA && response.data.blackListA.details
          ? JSON.parse(response.data.blackListA.details)
          : {};
      var blacklistlinks = response.data.blackListA
        ? response.data.blackListA.status
        : 2;
      var data = { spamScore, spamReport, blacklistDetails, blacklistlinks };
      cb(data);
    });
  },
  updateLink(params) {
    return http.post(LINK_CHECK, params);
  },
  createImage(params) {
    return http.post(CREATE_IMAGE, { id: params });
  },
  campaignanalyticsExport(params) {
    return http.post(CAMAPIGN_ANALYTICS_EXPORT, params);
  },
};
